module.exports = __webpack_public_path__ + "img/banner-keepgrow.0a3a8101.png";